import fp from 'lodash/fp';
import ReactDOM from 'react-dom';
import React, { ComponentType } from 'react';
import { Prioritized, prioritizeExtensions } from '@factorin/container';
import withDependencies from '@factorin/container.macro';

import { SizeContextProvider } from 'Modules/ui/components';

import { ChainedRender } from './types';


type RenderedChain = ComponentType<{ Next?: ChainedRender }>;

const reduceRender = (prev: RenderedChain, Current: ChainedRender): RenderedChain =>
    () => <Current Next={prev} />;

const render: (renderChain: Prioritized<ChainedRender>) => ComponentType = fp.pipe(
    prioritizeExtensions,
    fp.reduce(reduceRender, () => null),
);

const sizeContextRender: ChainedRender = ({ Next }) => (
    <SizeContextProvider>
        <Next />
    </SizeContextProvider>
);

export const react = {
    renderChain: [
        [sizeContextRender, 50],
    ] as Prioritized<ChainedRender>,

    Application: withDependencies((renderChain: Prioritized<ChainedRender>) =>
        render(renderChain)),

    runApplication: withDependencies((Application: ComponentType) => () => {
        ReactDOM.render(
            <Application />,
            document.getElementById('root'),
        );
    }),
};

export * from './BrowserRouterRender';
export * from './types';
